import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type { PortfolioListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";

type Props = {
	data: PortfolioListItemResponseDTO;
};

export const PortfolioTitle: FC<Props> = ({ data }) => {
	const { t } = useResource();
	const theme = useTheme();

	return (
		<Typography variant="bodyMedium" color={theme.palette.grey[900]} noWrap>
			{getTitle(data, t)}
		</Typography>
	);
};
